/* Dream Exito theme scripts */
(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (m && m[1]) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  var opener = document.querySelector('[data-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var f = drawer.querySelector('[data-drawer-close].icon-btn'); if (f) f.focus(); }
    else if (opener) opener.focus();
  }
  if (opener) opener.addEventListener('click', function () { setDrawer(true); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) setDrawer(false);
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var min = parseInt(input.getAttribute('min') || '0', 10);
    function bump(d) {
      var v = Math.max(min, (parseInt(input.value, 10) || 0) + d);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () { bump(-1); });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () { bump(1); });
  });

  /* ---------- Cart page: update on quantity change ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var t;
    cartForm.querySelectorAll('[data-cart-qty]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        clearTimeout(t);
        t = setTimeout(function () { cartForm.submit(); }, 450);
      });
    });
  }

  /* ---------- AJAX add to cart ---------- */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]:not(.shopify-payment-button__button)');
      if (!btn || btn.disabled) return;
      var label = btn.innerHTML;
      btn.disabled = true;
      fetch((window.theme.routes.cartAdd), {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart');
          return fetch(window.theme.routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCount(cart.item_count);
          btn.classList.add('is-added');
          btn.textContent = 'Added to Cart ✓';
          setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; btn.disabled = false; }, 1800);
        })
        .catch(function (err) {
          btn.innerHTML = label; btn.disabled = false;
          alert(err.message);
        });
    });
  });

  /* ---------- Product page: gallery + variants ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var slides = root.querySelectorAll('.pdp__slide');
    var thumbs = root.querySelectorAll('[data-thumb]');
    function showMedia(id) {
      if (!id) return;
      var found = false;
      slides.forEach(function (s) { var m = s.getAttribute('data-media-id') == id; s.classList.toggle('is-active', m); if (m) found = true; });
      if (!found && slides[0]) slides[0].classList.add('is-active');
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') == id); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); }); });
    var active = root.querySelector('.pdp__slide.is-active');
    if (active) showMedia(active.getAttribute('data-media-id'));

    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var stockEl = root.querySelector('[data-stock]');
    var shipNote = stockEl ? (stockEl.querySelector('.muted') || {}).outerHTML || '' : '';
    var optInputs = root.querySelectorAll('[data-opt]');
    if (!optInputs.length) return;

    function selected() {
      var vals = [];
      optInputs.forEach(function (i) { if (i.checked) vals[+i.getAttribute('data-opt')] = i.value; });
      return vals;
    }
    function onChange() {
      var vals = selected();
      vals.forEach(function (v, i) { var l = root.querySelector('[data-opt-label="' + i + '"]'); if (l) l.textContent = v; });
      var v = product.variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
      if (!v) {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false;
      } else { compareEl.hidden = true; }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      if (stockEl) stockEl.innerHTML = v.available ? '<span class="dot dot--ok"></span> In Stock ' + shipNote : '<span class="dot"></span> Sold out';
      if (v.featured_media) showMedia(v.featured_media.id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    optInputs.forEach(function (i) { i.addEventListener('change', onChange); });
  });

  /* ---------- Collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  /* ---------- Account: password recovery toggle ---------- */
  var rec = document.querySelector('[data-recover]');
  if (rec) rec.addEventListener('click', function () {
    var box = document.getElementById('recover'); if (box) box.classList.add('is-open');
  });
})();
